export function useLaravelPath() {
  const { locale } = useI18n();

  const laravelLocale = computed(() => {
    return locale.value.startsWith('en') ? 'en' : locale.value;
  });

  return (path: string) => {
    return `/${laravelLocale.value}${path}`;
  };
}